import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledList = styled.ul`
  margin-top: 5px;
  margin-bottom: 13px;
  padding-left: 0;
  li {
      list-style: none;
      font-size: 14px;
      line-height: 18px;
  }
  
  li::before {
      content:"·";
      font-size:30px;
      vertical-align:bottom;
      margin-right: 5px;
  }
`;

export const StyledText = styled(P)`
  margin-top: 13px;
  margin-bottom: 0;
  font-size: 14px;
`;

export const StyledTip = styled.span`
  span[type="button"] {
    transform: translateY(5px);
    padding-left: 15px;
    padding-top: 8px;
  }
  
  span[type="button"]::after {
    transform: translate(3px, -4px);
  }
`;

export const StyledToolTipContainer = styled.div`
  display: inline;
  position: absolute;
  margin-left: 5px;
  margin-top: -1px;
`;
